export const addPrefix = phoneNumber => phoneNumber && `+${phoneNumber}` || null;